import { ChevronRight } from "lucide-react";
import ROUTES from "../services/AppConstant";
import { useTranslation } from "react-i18next";
import { TEXT } from "../constant/textConstants";
import { ABOUTUS_ARRAY, FEATURES_ARRAY, QUESTION_ARRY } from "../lib/utils";

export default function Home() {
  const { t } = useTranslation();
  return (
    <div>
      <section id="home">
        <div className="mb-[50px] h-full w-full overflow-x-hidden bg-home-bg px-[15px] xl:px-0">
          <div className="m-auto flex max-w-7xl flex-col items-center pt-10 sm:relative sm:flex-row sm:pt-20">
            <div className="flex h-full w-full flex-wrap items-start break-words sm:min-w-[630px] md:px-0 lg:pr-[20px]">
              <div className="mb-[20px]">
                <p className="relative mb-[6px] w-full text-center text-[25px] font-bold leading-normal text-white sm:text-start sm:text-[3.80rem]">
                  {t(TEXT?.GLOBAL_BOOK_SOURCING_SERVICE)}
                </p>
                <p className="text-center text-sm text-white sm:text-start sm:text-lg lg:text-2xl">
                  {t(TEXT?.GLOBAL_E_COMMERCE_EXPANSION)}
                </p>
              </div>
              <div className="mb-[40px] mt-1 flex justify-center">
                <div className="flex space-x-16 text-white">
                  <div className="flex flex-col items-center justify-center text-center sm:flex-row sm:items-start">
                    <div className="flex items-end text-center">
                      <div className="text-3xl font-bold leading-none md:text-5xl">
                        3
                      </div>
                      <div className="font-bold leading-none md:text-[2rem]">
                        x
                      </div>
                    </div>
                    <div className="pl-1 text-lg">
                      {t(TEXT?.SHORTER_DELIVERY_TIME)}
                    </div>
                  </div>
                  <div className="flex flex-col items-center justify-center text-center sm:flex-row sm:items-start">
                    <div className="text-3xl font-bold md:text-5xl">1000%</div>
                    <div className="pl-1 text-lg">
                      {t(TEXT?.LARGE_SELECTION)}
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-5 flex w-full justify-center sm:mb-0 md:justify-start">
                <a
                  href={ROUTES?.SEARCH_API}
                  className="rounded-[4px] border-2 border-blue-500 bg-blue-500 px-[30px] py-[10px] text-white hover:border-2 hover:border-white hover:bg-transparent"
                >
                  <p className="text-lg">{t(TEXT?.SEARCH_API)}</p>
                </a>
              </div>
            </div>
            <div className="h-full w-full">
              <img
                src="/images/home/tablet-01.png"
                alt="tablet"
                className="w-auto sm:max-w-[1300px]"
                height={770}
                width={1200}
              />
            </div>
          </div>
        </div>
      </section>

      {/* ----section2---- */}
      <section id="features">
        <div className="pt-[50px]">
          <div className="m-auto max-w-7xl">
            <div className="flex justify-center">
              <div className="text-center">
                <div className="text-[1.1rem] font-semibold uppercase tracking-wider text-gray-700">
                  {t(TEXT?.ENDLESS_POSSIBILITIES)}
                </div>
                <h1 className="l mt-[30px] max-w-[700px] text-3xl font-semibold text-gray-900 md:text-[46px]">
                  {t(TEXT?.SOURCE_BOOKS_GLOBAL)}
                </h1>
                <p className="mt-4 text-xl text-gray-600 md:text-[24px]">
                  {t(TEXT?.OPERATION_GLOBAL)}
                </p>
              </div>
            </div>

            <div className="md:mt-[60px]">
              <div className="flex w-full flex-wrap items-start justify-center">
                {FEATURES_ARRAY?.map((list, i) => {
                  return (
                    <div
                      className="mb-4 flex flex-col items-center justify-center px-2 sm:w-1/2 md:flex-row md:items-start"
                      key={i}
                    >
                      <div className="h-full">
                        <img
                          src={list?.icon}
                          alt=""
                          height={100}
                          width={100}
                          className="min-h-[135px] min-w-[135px]"
                        />
                      </div>
                      <div>
                        <div className="mb-[10px] text-center text-[25px] font-bold text-black-1 md:text-start">
                          {t(list?.title)}
                        </div>
                        <div className="text-dark-gray text-center text-[1rem] md:text-start">
                          {t(list?.description)}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ----section3---- */}

      <div className="m-auto mt-[50px] max-w-7xl rounded-xl bg-home-section2">
        <div className="px-[15px] pb-[80px] pt-[80px] lg:px-[70px]">
          <div className="relative m-auto flex max-w-7xl flex-col-reverse items-center justify-center md:flex-row">
            <div className="sm:w-1/2">
              <p className="mb-[35px] text-[15px] uppercase text-dark-gray-1">
                {t(TEXT?.SYSTEM_THAT_WORKS)}
              </p>
              <div>
                <p className="mb-[26px] text-3xl text-dark-gray-1 sm:text-4xl xl:text-5xl">
                  {t(TEXT?.BOOKS_SHIPPED)}
                </p>
              </div>
              <div>
                <div className="mb-[18px] flex items-start">
                  <div className="mt-[8px] min-h-[6px] min-w-[6px] rounded-full bg-dark-gray-1" />
                  <p className="ml-[15px]">{t(TEXT?.JOIN_US)}</p>
                </div>
                <div className="mb-[18px] flex items-start">
                  <div className="mt-[8px] min-h-[6px] min-w-[6px] rounded-full bg-dark-gray-1" />
                  <p className="ml-[15px]">{t(TEXT?.INVITE_ONLY_SERVICE)}</p>
                </div>
              </div>
            </div>
            <div>
              <img
                src="/images/home/strategyBanner.png"
                alt=""
                height={652}
                width={575}
                className="xl:max-w-[675px]"
              />
            </div>
          </div>
        </div>
      </div>

      {/* ----section4---- */}

      <div className="m-auto mt-[100px] max-w-7xl rounded-xl pb-[85px]">
        <div className="relative m-auto flex max-w-7xl flex-col-reverse items-center justify-center sm:flex-row">
          <div>
            <img
              src="/images/home/engageBanner.png"
              alt=""
              height={652}
              width={575}
              className="xl:max-w-[675px]"
            />
          </div>
          <div className="ml-[30px] sm:w-[80%] lg:w-1/2">
            <p className="mb-[35px] text-[15px] uppercase text-dark-gray-1">
              {t(TEXT?.ORGANIZED_SOURCING)}
            </p>
            <div>
              <p className="mb-[26px] text-3xl text-dark-gray-1 sm:text-4xl lg:text-5xl">
                {t(TEXT?.CONNECT_ECOMMERCE)}
              </p>
              <p className="mb-[1rem] text-lg text-dark-gray-1">
                {t(TEXT?.BOOKSELLING_SETUP)}
              </p>
            </div>
            <div>
              <p className="mb-[20px] text-[27px] font-bold text-dark-gray-1">
                {t(TEXT?.GET_MORE_DONE)}
              </p>
              <div className="mb-[18px] flex items-start">
                <div className="mt-[8px] min-h-[6px] min-w-[6px] rounded-full bg-dark-gray-1" />
                <p className="ml-[15px]">{t(TEXT?.INITIATE_SEARCH_API)}</p>
              </div>
              <div className="mb-[18px] flex items-start">
                <div className="mt-[8px] min-h-[6px] min-w-[6px] rounded-full bg-dark-gray-1" />
                <p className="ml-[15px] text-dark-gray-1">
                  {t(TEXT?.ORDER_API)}
                </p>
              </div>
              <div className="mb-[18px] flex items-start">
                <div className="mt-[8px] min-h-[6px] min-w-[6px] rounded-full bg-dark-gray-1" />
                <p className="ml-[15px] text-dark-gray-1">
                  {t(TEXT?.NO_HASSLE)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ----How it work section---- */}
      <div className="relative m-auto max-w-7xl pb-[80px]">
        <div className="flex justify-center p-[8px] md:p-[15px]">
          <div>
            <p className="text-center text-4xl font-semibold text-dark-gray-1 md:text-[2.875rem]">
              {t(TEXT?.HOW_IT_WORKS)}
            </p>
            <div className="mt-[18px] flex w-full justify-center">
              <p className="text-center text-[1.3125rem] text-dark-gray-1 sm:w-[60%]">
                {t(TEXT?.AUSTRIA_HOME_COUNTRY)}
              </p>
            </div>
          </div>
        </div>
        <div className="mt-[40px] flex flex-wrap lg:mt-[75px]">
          <div className="mb-[30px] flex-[0,0,auto] justify-center px-2 text-center sm:w-[50%] lg:w-[33.33%]">
            <div className="mx-[8px] mb-[60px] flex justify-center rounded-t-[12px] bg-gradient-purple pt-[42px]">
              <img
                src="/images/home/howitwork1.png"
                alt=""
                className="w-auto sm:max-h-[200px]"
                height={175}
                width={272}
              />
            </div>
            <div className="text-center">
              <h6 className="mb-[15px] text-[25px] font-bold text-dark-gray-1">
                {t(TEXT?.FOREIGN_BOOKS_TO_AUSTRIA)}
              </h6>
              <p className="text-lg text-dark-gray-1">
                {t(TEXT?.FOREIGN_BOOKS_DEFINITION)}
              </p>
            </div>
          </div>
          <div className="mb-[30px] flex-[0,0,auto] justify-center px-2 text-center sm:w-[50%] lg:w-[33.33%]">
            <div className="mx-[8px] mb-[60px] flex justify-center rounded-t-[12px] bg-gradient-purple pt-[42px]">
              <img
                src="/images/home/howitwork2.jpg"
                alt=""
                className="w-auto sm:max-h-[200px]"
                height={175}
                width={272}
              />
            </div>
            <div className="text-center">
              <h6 className="mb-[15px] text-[25px] font-bold text-dark-gray-1">
                {t(TEXT?.INTERNATIONAL_PRIORITY_DELIVERY)}
              </h6>
              <p className="text-lg text-dark-gray-1">
                {t(TEXT?.BOOKS_PACKED_DELIVERY)}
              </p>
            </div>
          </div>
          <div className="mb-[30px] flex-[0,0,auto] justify-center px-2 text-center sm:w-[50%] lg:w-[33.33%]">
            <div className="mx-[8px] mb-[60px] flex justify-center rounded-t-[12px] bg-gradient-purple pt-[42px]">
              <img
                src="/images/home/howitwork3.jpg"
                alt=""
                className="w-auto sm:max-h-[200px]"
                height={175}
                width={272}
              />
            </div>
            <div className="text-center">
              <h6 className="mb-[15px] text-[25px] font-bold text-dark-gray-1">
                {t(TEXT?.PREPACKED_ORDERS)}
              </h6>
              <p className="text-lg text-dark-gray-1">
                {t(TEXT?.SUBMIT_LABEL)}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* ---- About us ---- */}
      <section id="about">
        <div className="md:py-[85px]">
          <div className="relative m-auto flex flex-col sm:max-w-7xl lg:flex-row">
            <div className="w-full sm:w-[42%] sm:min-w-[550px]">
              <div className="relative flex w-full flex-wrap items-center p-[15px]">
                <div className="mb-[20px]">
                  <h2 className="mb-[50px] text-3xl font-bold text-dark-gray-1 md:text-[53px]">
                    {t(TEXT?.ABOUT_US)}
                  </h2>
                  <p className="mb:text-[24px] mb-[18px] text-xl text-dark-gray-1">
                    {t(TEXT?.FAMILY_BUSINESS_HISTORY)}
                  </p>
                  <div className="mb-[18px] flex items-start">
                    <div className="mt-[8px] min-h-[6px] min-w-[6px] rounded-full bg-dark-gray-1" />
                    <p className="ml-[15px] text-lg text-dark-gray-1">
                      {t(TEXT?.MARKET_EXPANSION)}
                    </p>
                  </div>
                </div>
                <div>
                  <a href={ROUTES?.SEARCH_API} className="">
                    <div className="flex items-center">
                      <p className="text-[18px] text-blue-600">
                        {t(TEXT?.GET_STARTED)}
                      </p>
                      <div>
                        <ChevronRight className="ml-3 pt-1 text-blue-600" />
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap">
              {ABOUTUS_ARRAY?.map((list, i) => {
                return (
                  <div className="px-[10px] md:w-1/2 xl:px-[13px]" key={i}>
                    <div className="mb-[30px] rounded-[12px] bg-white p-[25px] text-start shadow-AboutUs xl:p-[35px]">
                      <div className="flex h-full justify-center sm:justify-start">
                        <img
                          src={list?.icon}
                          alt=""
                          height={100}
                          width={100}
                          className="min-h-[135px] min-w-[135px]"
                        />
                      </div>
                      <div>
                        <div className="mb-[10px] text-center text-[25px] font-bold text-black-1 sm:text-start">
                          {t(list?.title)}
                        </div>
                        <div className="text-dark-gray text-center text-[1rem] sm:text-start">
                          {t(list?.description)}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* ----Quesions ---- */}
      <section id="question-and-answer">
        <div className="m-auto max-w-7xl px-[15px] pt-9 md:pt-[85px] xl:px-0">
          <div className="mb-[70px] flex w-full justify-center">
            <div>
              <p className="text-center text-4xl font-bold text-dark-gray-1 md:text-[3.125rem]">
                {t(TEXT?.QUESTIONS_ANSWERS)}
              </p>
              <p className="mt-[18px] w-full text-center text-[24px] text-light-gray-1">
                {t(TEXT?.CHECK_QUESTIONS_ANSWERED)}
                <a href={ROUTES?.CONTACT_US} className="text-blue-600">
                  {" "}
                  {t(TEXT?.CONTACT_US)}
                  {"."}
                </a>
              </p>
            </div>
          </div>
          <div className="flex w-full flex-wrap gap-[30px] text-left">
            {QUESTION_ARRY?.map((list, i) => {
              return (
                <div className="flex flex-wrap lg:w-[48%]" key={i}>
                  <div className="flex flex-col">
                    <p className="mb-[18px] text-xl text-dark-gray-1 md:text-[25px]">
                      {list?.count}. {t(list?.question)}
                    </p>
                    <p className="mb-[18px] text-base text-light-gray-1 md:text-lg">
                      {t(list?.answer)}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="mt-[40px] flex justify-center">
            <div className="flex rounded-[100px] bg-sky px-[20px] py-[22px] md:px-[46px]">
              <div className="text-[18px]">{t(TEXT?.ANY_QUESTIONS)}</div>
              <a
                href={ROUTES?.CONTACT_US}
                className="pl-1 text-[18px] text-blue-600"
              >
                {t(TEXT?.GET_IN_TOUCH)}
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
